export default "/institutions/clear.svg";